<template>
  <div v-if="!showPast" class="mb-4">
    <button class="g--button" @click="activeClass = {}; showEditClass = true">Add a class</button>
  </div>
  <div class="flex items-start justify-center min-h-screen" v-if="loading">
    <Spinner></Spinner>
  </div>
  <div v-else-if="classes.length === 0">
    <p class="text-center">No classes found.</p>
  </div>
  <div v-else>
    <div class="border-b p-6 rounded-md mb-4 bg-white" v-bind:key="classItem.id" v-for="classItem in classes">
      <div class="flex justify-between mb-2">
        <div class="flex items-end">
          <div class="text-2xl font-medium ">{{ classItem.yogaType }}</div>
          <div class="ml-2 text-[13px] text-black/70" v-if="classItem.privateClass">Private class</div>
        </div>
        <div>
          <button @click="activeClass = classItem; showEditClass = true" class="g--button g--button--small">Edit class
          </button>
          <a target="_blank" :href="classItem.url"
             class="ml-4 g--button g--button--small">View public page</a></div>
      </div>
      <div v-if="classItem.classDescriptionTeacher">
        <div class="text-md mb-2 text-gray-600 ">{{ classItem.classDescriptionTeacher }}</div>
      </div>
      <div class="flex gap-2">
        <div v-for="tag in classItem.tags" class="g--tag  items-center">
          <span class="mr-2">{{ tag.emoji }}</span>
          {{ tag.title }}
        </div>
      </div>
      <div class="mt-2 flex items-center mb-4"><span
          class="text-xl font-lighter  inline-block mr-4">{{ classItem.priceFriendly }}</span>
      </div>
      <ClassSessions :with-year="showPast"  :sessions="classItem.sessions"></ClassSessions>
      <div class="flex items-center justify-between mt-4">
        <button class="g--button g--button--block ml-0 "
                @click="activeClass = classItem; showAddSession = true">Add a session
        </button>
        <a v-if="!showPast" class="ml-4 text-sm hover:underline" :href="'/teachers/classes/' + classItem.slug">View all sessions</a>
        <a v-else class="ml-4 text-sm hover:underline" :href="'/teachers/classes/'">Back to classes</a>
      </div>
    </div>

  </div>
  <Teleport to="body">
    <div v-if="showEditClass" class="fixed z-50 inset-0 bg-black bg-opacity-50 flex items-center justify-center"
         @click="handleBackdropClick">
      <div class="bg-white rounded-lg w-[90%] max-w-[600px] h-[87%] mt-[64px] overflow-y-auto" @click.stop>
        <EditClass :needs-video-link="needsVideoLink" :class-item="activeClass" v-if="showEditClass"
                   @entry-saved="showEditClass = false; fetchClasses();"></EditClass>
      </div>
    </div>
    <div v-if="showAddSession" class=""
         @click="handleBackdropClick">
      <!--      <div class="bg-white rounded-lg w-[90%] max-w-[600px] h-[90%] overflow-y-auto" @click.stop>-->
      <AddSession :class-item="activeClass" v-if="showAddSession" @click.stop
                  @session-added="showAddSession = false; fetchClasses();"></AddSession>
      <!--      </div>-->
    </div>
  </Teleport>

</template>

<script setup>
import { ref, onMounted } from 'vue';
import EditClass from './EditClass.vue';
import AddSession from './AddSession.vue';
import ClassSessions from './ClassSessions.vue';
import Spinner from './Spinner.vue';

const loading = ref(true);
const classes = ref([]);
const showEditClass = ref(false);
const activeClass = ref(false);
const showAddSession = ref(false);

const props = defineProps({
  teacherId: {
    type: Number,
    required: true,
  },
  classId: {
    type: Number,
    default: 0,
  },
  showPast: {
    type: Number,
    default: 0,
  },
  needsVideoLink: {
    type: Boolean,
    default: false,
  },
});

onMounted(() => {
  fetchClasses();
});

const fetchClasses = async () => {
  const response = await fetch('/api/classes/all?withSessions=1&teacherId=' + props.teacherId + '&classId=' + props.classId + '&showPast=' + props.showPast);
  const data = await response.json();
  classes.value = data.classes;
  loading.value = false;
};

const handleBackdropClick = () => {
  showEditClass.value = false;
  showAddSession.value = false;
  activeClass.value = {};
};

</script>